import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import DataGridContext from './data-grid.context';
import GridHeader from './data-grid-header';
import GridBody from './data-grid-body';

/**
 * @typedef {'text' | 'email' | 'url' | 'password' | 'number' | 'date' | 'datetime-local' | 'month' | 'search' | 'tel' | 'time' | 'week'} InputTypes
 */

/**
 * A fast and extendable react data table
 * @param {{
 *   className?: string,
 *   columns: {field: string, headerName: string, [type]: InputTypes|'select'}[],
 *   onDelete: function,
 *   onUpdate: function,
 *   rows: any[],
 * }} props
 * @return {JSX.Element}
 * @constructor
 */
const DataGrid = (props) => {
  const {
    className,
    columns = [],
    onDelete,
    onUpdate,
    rows = [],
  } = props;

  const setRowIndex = (/** number */ index) => setState(state => ({ ...state, currentRowIndex: index }));

  const [state, setState] = useState({
    currentRowIndex: null,
    setRowIndex,
    onDelete,
    onUpdate,
  });

  React.useEffect(() => {
    setState(state => ({ ...state, onUpdate, onDelete }));
  }, [onUpdate, onDelete]);

  /**
   * We use the DataGrid context provider to manage 'currentRowIndex', ...
   * This way we don't need to pass down these props.
   */
  return (
    <DataGridContext.Provider value={state}>
      <div className={twMerge('table w-full rounded-md overflow-hidden', className)}>
        <GridHeader columns={columns}/>
        <GridBody columns={columns} rows={rows}/>
        {/* TODO: GridFooter */}
      </div>
    </DataGridContext.Provider>
  );
};

DataGrid.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  className: PropTypes.string,
};

export default DataGrid;
